module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-card-wrapper"
  }, [_c('transition-group', {
    class: 'ui stackable doubling ' + _vm.getCardsLayoutSize + ' cards',
    attrs: {
      "name": "fadeDown",
      "mode": "out-in",
      "tag": "div"
    }
  }, _vm._l((_vm.paginatedProducts), function(product) {
    return _c('a', {
      key: product.productId,
      class: ['product-card', 'ui card'],
      attrs: {
        "title": product.productTitle || 'Product'
      },
      on: {
        "click": function($event) {
          return _vm.showProductDetails(product.productId)
        }
      }
    }, [_c('div', {
      staticClass: "card-stripe",
      class: _vm.getBuyBoxStatus(product) ? _vm.getCardStripeClass(_vm.getBuyBoxStatus(product)) : 'unknown'
    }), _vm._v(" "), _c('div', {
      staticClass: "card-image-area"
    }, [(product.largeImageUrl) ? _c('img', {
      staticClass: "card-product-image",
      attrs: {
        "src": product.largeImageUrl,
        "alt": ""
      }
    }) : _c('svg', {
      staticClass: "placeholder",
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2",
        "y": "7",
        "width": "20",
        "height": "14",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"
      }
    })]), _vm._v(" "), (_vm.getAlertCount(product) > 0) ? _c('div', {
      staticClass: "card-alert-badge"
    }, [_vm._v(_vm._s(_vm.getAlertCount(product)) + " alert" + _vm._s(_vm.getAlertCount(product) !== 1 ? 's' : ''))]) : _vm._e(), _vm._v(" "), (_vm.getBuyBoxStatus(product)) ? _c('div', {
      staticClass: "card-bb"
    }, [_c('span', {
      staticClass: "bb-badge",
      class: _vm.getCardStripeClass(_vm.getBuyBoxStatus(product))
    }, [_vm._v(_vm._s(_vm.getBuyBoxLabel(_vm.getBuyBoxStatus(product))))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "card-market"
    }, [_c('span', {
      staticClass: "market-tag"
    }, [_vm._v(_vm._s(_vm.getMarketplaceEmoji(product.marketplace.toUpperCase())) + " " + _vm._s(product.marketplace))])]), _vm._v(" "), _c('div', {
      staticClass: "card-name",
      attrs: {
        "title": product.productTitle
      }
    }, [_vm._v(_vm._s(_vm.truncateToTwoLines(product.productTitle)))]), _vm._v(" "), _c('div', {
      staticClass: "card-asin"
    }, [_vm._v(_vm._s(_vm.getAsin(product)))]), _vm._v(" "), _c('div', {
      staticClass: "card-rating",
      attrs: {
        "title": product.reviewHealthStatus === 'red' ? (product.reviewHealthNote || '') : null
      }
    }, [_vm._v(_vm._s(_vm.ratingSummary(product.rating, product.reviewCount))), (product.reviewHealthStatus === 'red') ? _c('span', {
      staticClass: "card-rating-dot"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-cogs-strip",
      class: {
        missing: !_vm.hasProductCogs(product)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.hasProductCogs(product)) ? [_c('div', {
      staticClass: "cogs-col cogs-col-clickable",
      attrs: {
        "title": "Edit product cost and margin"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_c('div', {
      staticClass: "cogs-strip-label"
    }, [_vm._v("COGS")]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-value"
    }, [_vm._v("$" + _vm._s(_vm.formatPrice(_vm.getProductCogs(product))))])]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "cogs-col cogs-col-add cogs-col-with-edit"
    }, [_c('div', {
      staticClass: "cogs-strip-label"
    }, [_vm._v("Margin")]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-value",
      class: _vm.getMarginCogsClass(_vm.calculateMargin(product))
    }, [_vm._v(_vm._s(_vm.calculateMargin(product)) + "%")]), _vm._v(" "), _c('span', {
      staticClass: "add-cogs edit-cogs-link",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("Edit COGS")])])] : [_c('div', {
      staticClass: "cogs-col"
    }, [_c('div', {
      staticClass: "cogs-strip-label"
    }, [_vm._v("COGS")]), _c('div', {
      staticClass: "cogs-strip-value empty"
    }, [_vm._v("Not set")])]), _vm._v(" "), _c('div', {
      staticClass: "cogs-strip-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "cogs-col cogs-col-add"
    }, [_c('span', {
      staticClass: "add-cogs",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openCogsModal(product)
        }
      }
    }, [_vm._v("+ Add COGS")])])]], 2)]), _vm._v(" "), _c('div', {
      staticClass: "card-footer"
    }, [_c('span', {
      staticClass: "card-footer-sales"
    }, [_c('strong', [_vm._v(_vm._s(product.salesYesterday))]), _vm._v(" units ystd.")]), _vm._v(" "), _c('div', {
      staticClass: "action-btn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.$parent.$parent.$refs.chartModal && _vm.$parent.$parent.$refs.chartModal.open(product, null)
        }
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "2"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "22 12 18 12 15 21 9 3 6 12 2 12"
      }
    })])])])])
  }), 0), _vm._v(" "), _c('ProductCostMarginModal', {
    ref: "productCostMarginModal",
    on: {
      "cost-margin-updated": _vm.handleCostMarginUpdated
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4095c260!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductCard.vue
// module id = 759
// module chunks = 2